import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const LastNewsThunk = createAsyncThunk(
	'LastNewsThunk',
	async (_, ThunkApi) => {
		const { rejectWithValue } = ThunkApi;
		try {
			const res = await axios.get('https://api.act2hf.com/api/public/news');

			return res?.data;
		} catch (error) {
			return rejectWithValue(error.response.data);
		}
	},
);
